type AllocationWithStartDate = { startDate?: Date | string | null };

type DtoWithAllocations = {
  startDate?: Date | string;
  endDate?: Date | string;
  allocations?: AllocationWithStartDate[];
};

export const isAllocationOutOfBookingRange = (
  allocation: AllocationWithStartDate,
  endDate: Date | string,
  startDate?: Date | string,
) => new Date(allocation.startDate ?? startDate!).getTime() >= new Date(endDate).getTime();

export const getOutOfRangeAllocationIndices = (
  allocations: AllocationWithStartDate[] | undefined,
  endDate: Date | string,
  startDate?: Date | string,
): number[] =>
  (allocations ?? []).flatMap((allocation, index) =>
    isAllocationOutOfBookingRange(allocation, endDate, startDate) ? [index] : [],
  );

export const filterOutOfRangeAllocations = <T extends DtoWithAllocations>(dto: T): T => {
  if (!dto.endDate || !dto.allocations?.length) {
    return dto;
  }

  const indicesToRemove = new Set(
    getOutOfRangeAllocationIndices(dto.allocations, dto.endDate, dto.startDate),
  );
  if (indicesToRemove.size === 0) {
    return dto;
  }

  return {
    ...dto,
    allocations: dto.allocations.filter((_, index) => !indicesToRemove.has(index)),
  };
};
